const formatCurrency = (
  amount: number,
  currency = 'CAD',
  locale = navigator.language,
) => {
  const formattedAmount = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    currencyDisplay: 'symbol',
  }).format(amount);

  if (currency === 'USD' && formattedAmount.startsWith('$')) {
    return `US${formattedAmount}`;
  }

  return formattedAmount;
};

export default formatCurrency;
